import { render, staticRenderFns } from "./AddProductComponent.vue?vue&type=template&id=f3b7cc4e&scoped=true"
import script from "./AddProductComponent.vue?vue&type=script&lang=js"
export * from "./AddProductComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b7cc4e",
  null
  
)

export default component.exports